import { LogLevel, type ILogger } from '@microsoft/signalr';

export const createHubLogger = (hubName: string): ILogger => ({
  log: (logLevel: LogLevel, message: string) => {
    if (
      message.includes('sending data') ||
      message.includes('type') ||
      message.includes('ping')
    ) {
      console.log(`[SignalR ${hubName}] [${LogLevel[logLevel]}]`, message);
    } else if (logLevel >= LogLevel.Warning) {
      console.warn(`[SignalR ${hubName}] [${LogLevel[logLevel]}]`, message);
    }
  },
});
